import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: 'Главная' },
  { to: '/telegram-leads', label: 'Telegram чаты' },
  { to: '/ai-sales', label: 'AI рассыльщик' },
  { to: '/competitors', label: 'Перехват' },
  { to: '/integrations', label: 'Интеграции' },
  { to: '/mass-mailing', label: 'Рассылка под ключ' },
  { to: '/leads-turnkey', label: 'Заявки под ключ' },
  { to: '/partner', label: 'Партнёрская программа' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-xl border-b border-background-200 shadow-[0_1px_2px_oklch(var(--background-900)/0.03)]'
          : 'bg-background-50 border-b border-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-16 md:h-[72px] px-6 md:px-10 max-w-[1280px] mx-auto">
        <Link
          to="/"
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="w-7 h-7 rounded-md bg-primary-500 flex items-center justify-center">
            <i className="ri-flashlight-fill text-background-50 text-base"></i>
          </span>
          <span className="font-display font-extrabold text-[20px] tracking-tightest text-foreground-950">
            AIGAM
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-[14px] font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === link.to
                  ? 'text-foreground-950'
                  : 'text-foreground-600 hover:text-foreground-950'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3 ml-8 pl-8 border-l border-background-200/80">
          <a
            href="https://lk.aigam.ru"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[14px] font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
          >
            Вход
          </a>
          <a
            href="https://lk.aigam.ru"
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 h-10 inline-flex items-center rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-[14px] font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            Получить демо
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 rounded-md flex items-center justify-center text-foreground-950 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Меню"
        >
          <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-6 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-[14px] font-medium py-2 ${
                location.pathname === link.to
                  ? 'text-foreground-950'
                  : 'text-foreground-600'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="flex gap-3 pt-2">
            <a
              href="https://lk.aigam.ru"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 text-center px-4 py-2.5 text-[14px] font-medium rounded-md border border-background-200 text-foreground-700 hover:bg-background-100 whitespace-nowrap cursor-pointer"
            >
              Вход
            </a>
            <a
              href="https://lk.aigam.ru"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 text-center px-4 py-2.5 text-[14px] font-semibold rounded-md bg-primary-500 text-background-50 whitespace-nowrap cursor-pointer"
            >
              Получить демо
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
